.cd{display:inline-flex;}